/* eslint-disable no-unsafe-optional-chaining */
import { useState } from 'react';
import { Typography } from 'ui';
import { TypeScales } from 'ui/primitives';
import { Title } from '../Home/Title';
import NewsCard from '../cards/NewsCard';
import s from './LatestNews.module.scss';
export const LatestNews = ({
  data,
  heading,
  showTextShadowHeading = false,
}) => {
  const [sortedByDate, setSortedByDate] = useState(
    data?.sort((a, b): any => {
      if (a.updatedAt > b.updatedAt) return -1;
      if (a.updatedAt < b.updatedAt) return 1;
      return 0;
    })
  );
  return (
    <div className={s.root}>
      <div className={s.text}>
        {showTextShadowHeading ? (
          <div className={s.shadowTitle}>
            <Title
              bgTitle="LATEST NEWS"
              title="Latest News and Trends in the Automotive Industry"
            />
          </div>
        ) : (
          <Typography
            label={heading}
            variant={TypeScales.h1}
            className={s.heading}
          />
        )}
        {/* <div className={cn(s.btn, 'cmn_only_desktop')}>
          <a href="/">View more news</a>
        </div> */}
      </div>
      <div className={s.list}>
        {sortedByDate
          ?.filter((obj, idx) => idx < 3)
          .map((obj) => (
            <NewsCard
              image={obj?.backgroundImage?.data?.attributes?.url}
              heading={obj.heroTitle}
              subheading={obj?.heroSubtitle || obj?.jumbo}
              url={obj.seoCanonicalUrl}
              key={obj?.heroTitle}
            />
          ))}
      </div>
      {/* <a className={cn(s.mobile_link, 'cmn_only_mobile')} href="/">
        <span>View more news</span>
        <ChevronRight primaryColor={Color.interaction_buttons} height={15} />
      </a> */}
    </div>
  );
};
